import React from "react";
import { observer } from "mobx-react-lite";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import platformTransformationStore from "../../stores/platform-transformation-store";
import PlatformTransformationSteps from "../platform-transformation-steps/platform-transformation-steps";
import "../../migrate-global-e-merchants.scss";

const PlatformTransformationResult: React.FC = observer(() => {
    const result = platformTransformationStore.lastResult;
    if (!result) {
        return null;
    }

    const steps = result.attempt.steps;
    const activationSkipped = steps.some(
        (step) => step.step_name === "ActivateNewStoreStep" && step.status === "skipped",
    );
    const successWithSkippedActivation = result.success && activationSkipped;

    let headlineColor = FONT_COLOR.SEMANTIC_DANGER;
    let headlineText = `Transformation failed (#${result.old_portal_id} → #${result.new_portal_id}).`;
    if (successWithSkippedActivation) {
        headlineColor = FONT_COLOR.SEMANTIC_WARNING;
        headlineText =
            "Transformation process has been completed successfully but was not activated. Please contact the merchant to get their approval for activating and then activate";
    } else if (result.success) {
        headlineColor = FONT_COLOR.SEMANTIC_SUCCESS;
        headlineText = `Transformation completed (#${result.old_portal_id} → #${result.new_portal_id}).`;
    }

    return (
        <div className="results-message platform-transformation-result">
            <FontBody1 color={headlineColor} variant={FONT_VARIANT.BOLD}>
                {headlineText}
            </FontBody1>

            {result.attempt.failure_reason && (
                <FontBody1 color={FONT_COLOR.SEMANTIC_DANGER}>
                    {result.attempt.failure_reason}
                </FontBody1>
            )}

            <PlatformTransformationSteps steps={steps} />
        </div>
    );
});

export default PlatformTransformationResult;
